
import { Vue, Component, Prop } from "vue-property-decorator";
// Entities
import { Company, Profile } from "@/entities/index";
// Services
import { getPiecesInStock } from "@/services";

@Component
export default class Chart1 extends Vue {
  @Prop() readonly warehouseCode!: string;
  client = this.company.codeLogistic || this.profile.company.codeLogistic;
  integrateStepZero = this.company.integrateStepZero;
  optionPalette = this.company.optionPalette;

  total = 0;
  totalPallet = 0;
  piecesInStock: number[] = [];

  optionsPiecesInStock = {
    labels: [
      this.$t("dataDashboard.charts.chart1.piecesInStock"),
      this.$t("dataDashboard.charts.chart1.orderedPieces"),
      this.$t("dataDashboard.charts.chart1.blockedPieces"),
    ],
    colors: ["#154077", "#aabb00", "#f1c24b"],
  };

  get profile(): Profile {
    return this.$store.getters.profile;
  }

  get company(): Company {
    return this.$store.getters.company;
  }

  async loadPiecesInStock(): Promise<void> {
    const { piecesInStock, total, totalPallet } = await getPiecesInStock({
      client: this.client,
      warehouse: this.warehouseCode,
      integrateStepZero: this.integrateStepZero,
      optionPalette: this.optionPalette,
    });
    this.piecesInStock = piecesInStock;
    this.total = total;
    this.totalPallet = totalPallet;
  }
}
